import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { OutputManagerPanelComponent } from './output-manager-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [OutputManagerPanelComponent],
  exports: [OutputManagerPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OutputManagerModule {}

export { OutputManagerPanelComponent }
